import { create } from 'zustand'
import { getAllByCase, getAllByCasePageable, save as storeBinnacle } from '@services/binnacles'

export const useBinnaclesStore = create((set, get) => ({
  // Estado inicial
  data: [],
  
  // Estados de loading/error
  loading: false,
  error: null,

  // Acciones para manejo de binnacles
  fetchAllByCase: async (caseId, onlyHospitalSupervision = false) => {
    try {
      set({ loading: true, error: null })
      const response = await getAllByCase(caseId, onlyHospitalSupervision)
      set({ data: response.data, loading: false })
      return response
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  fetchAllByCasePageable: async (caseId, pageNumber) => {
    try {
      set({ loading: true, error: null })
      const response = await getAllByCasePageable(caseId, pageNumber)
      set({ data: response.data, loading: false })
      return response
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  store: async (data, caseId, slug, isPageable = false) => {
    try {
      set({ loading: true, error: null })
      
      // Guardar en el servidor
      await storeBinnacle(data, slug)
      
      // Refrescar datos (igual que en la saga)
      if (isPageable) {
        await get().fetchAllByCasePageable(caseId)
      } else {
        await get().fetchAllByCase(caseId)
      }
    } catch (error) {
      set({ error: error.message, loading: false })
      throw error
    }
  },

  // Acción para actualizar directamente los datos (equivalente a GET_ALL_BY_CASE)
  setData: (data) => {
    set({ data })
  },

  clearError: () => set({ error: null }),
  
  // Reset del store
  reset: () => set({ data: [], loading: false, error: null })
})) 